import React from "react";
import { NavLink } from "react-router-dom";
import { ROUTES } from "../routes/routes";

export default function View({ url = { link: {} } }) {
    console.log(ROUTES[url?.link].path);
    return (
        <div className="more-button">
            <NavLink to={ROUTES[url?.link].path}> See more </NavLink>
        </div>
    );
}
